export const ServerPreview = {
  flow: 'column',
  align: 'center space-between',
  gap: 'B',
  round: 'Z2',
  padding: 'Z2 A1',
  borderWidth: '1px',
  borderStyle: 'solid',
  theme: 'common-card-outline',
  SectionHeader: {
    margin: '0',
    padding: '0',
    title: 'Development',
  },
};